module.exports = __webpack_public_path__ + "static/media/logo-beta.dbcb4029.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/AppHeader/assets/logo-beta.svg
// module id = ./src/common/AppHeader/assets/logo-beta.svg
// module chunks = 14